import React from 'react';
import theme from '@/mui/theme';
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import SiteLayout from "@/components/layout/site";
import Fasce from '@/components/layout/site/fasce';
import RealizzazioniHeading from '@/components/fasce/RealizzazioniHeading';
import VerticalSlider from '@/components/fasce/VerticalSlider';
import RichText from '@/components/ui/RichText';
import { PageType } from '@/utils/router';

const MainContainer = styled(Container)({
  marginTop: "35px",
  marginBottom: "50px",
  [theme.breakpoints.up('md')]: {
    marginTop: "50px",
    marginBottom: "100px",
  },
});

const ProjectLayout = ({ data }: any) => {
  const post = data?.posts?.nodes?.[0];
  const subCategory = post?.categories?.edges?.find((item: any) => item?.node?.parentId !== null)?.node
  const gallery = post?.fieldsGalleria?.galleria;

  return (
    <SiteLayout pageType={PageType.POST_DETAIL} data={data} translations={post?.translations} seo={post?.seo} language={post?.language}>
      {post && <>
        <RealizzazioniHeading
          occhiello={post?.fieldsRealizzazioni?.locality}
          title={post.title}
          tag={subCategory?.name}
          info={post?.fieldsRealizzazioni?.info}
        />
        {gallery &&
          <VerticalSlider slides={gallery} />
        }
        <MainContainer fixed>
          <Grid container>
            <Grid item sx={{ display: { xs: 'none', md: 'block' } }} md={1} lg={2} />
            <Grid item xs={12} md={10} lg={8}>
              <RichText content={post.content} />
            </Grid>
          </Grid>
        </MainContainer>
        <Fasce fasce={post.template?.fasce} translations={post?.translations}></Fasce>
      </>}
    </SiteLayout>
  );
};

export default ProjectLayout;
